export const List = {
    MuiList: {
        styleOverrides: {
            root: ()=>({
                    padding: 0
                })
        }
    }
};

//# sourceMappingURL=List.js.map